import { MainLayout } from "@/shared/layouts/main"
import { CommonLayout } from "@/shared/layouts/common"
import { Box, GridItem } from "@/shared/components"
import { EditStrategiesContainer } from "@/management/components"

export const EditStrategies = () => {
  return (
    <CommonLayout>
      <MainLayout mobileFullBleed={false}>
        <GridItem column={{ "@initial": "1 / span 6", "@sm": "1 / span 12", "@lg": "1 / span 24" }}>
          <Box css={{ padding: "$32" }}>
            <EditStrategiesContainer />
          </Box>
        </GridItem>
      </MainLayout>
    </CommonLayout>
  )
}
